import cf from './cf';
import i10v from './i10v_20211024';

export default class i10v1a extends i10v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'i10v1a';
    this.d_viewDefs = {
      name: '室・設備'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
